import React, { createContext, useState, useCallback } from "react";

export const TaskListSettingsContext = createContext({
    photography: {
        initialized: false,
    },
});

export const TaskListSettingsProvider = ({ children }) => {
    const [taskSettings, setTaskSettings] = useState({
        duplicatestaging: {
            preserveDefault: false,
            sourcePage: "duplicatestaging",
        },
        photography: {
            preserveDefault: false,
            sourcePage: "photography",
        },
        coding: {
            preserveDefault: false,
            sourcePage: "coding",
        },
        codingqa: {
            preserveDefault: false,
            sourcePage: "codingqa",
        },
        measuring: {
            preserveDefault: false,
            sourcePage: "",
        },
        finalqa: {
            preserveDefault: false,
            sourcePage: "finalqa",
        },
        imageediting: {
            preserveDefault: false,
            sourcePage: "imageediting",
        },
        imageeditingqa: {
            preserveDefault: false,
            sourcePage: "imageeditingqa",
        },
        brandverifiedqa: {
            preserveDefault: false,
            sourcePage: "brandverifiedqa",
        },
    });

    const handlePreserveDefaultFor = useCallback(
        (task) => {
            setTaskSettings({
                ...taskSettings,
                [task]: {
                    ...taskSettings[task],
                    preserveDefault: true,
                },
            });
        },
        [taskSettings]
    );

    return (
        <TaskListSettingsContext.Provider value={{ taskSettings, preserveDefaultFor: handlePreserveDefaultFor }}>
            {children}
        </TaskListSettingsContext.Provider>
    );
};
